import React from 'react';
import { motion } from 'framer-motion';
import { revealVariants } from '../utils/animations';
const steps = [{
  num: '01',
  title: 'Nos escribís',
  desc: 'Contacto rápido por WhatsApp.'
}, {
  num: '02',
  title: 'Definimos estilo',
  desc: 'Elegimos la estética ideal para tu marca.'
}, {
  num: '03',
  title: 'Diseñamos tu web',
  desc: 'Creamos la experiencia visual.'
}, {
  num: '04',
  title: 'Publicamos en 72hs',
  desc: 'Tu negocio online y listo para vender.'
}];
export function ProcessTimeline() {
  return <section id="proceso" className="py-20 md:py-32 relative" data-id="element-323">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-324">
        <motion.div variants={revealVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-24" data-id="element-325">
          <h2 className="text-4xl md:text-6xl font-bold tracking-tighter text-white mb-6" data-id="element-326">
            Un proceso diseñado <br className="hidden md:block" data-id="element-327" /> para no
            hacerte perder tiempo.
          </h2>
        </motion.div>

        <div className="relative" data-id="element-328">
          <div className="absolute top-1/2 left-0 w-full h-px bg-white/10 -translate-y-1/2 hidden md:block" data-id="element-329"></div>

          <motion.div initial={{
          width: 0
        }} whileInView={{
          width: '100%'
        }} transition={{
          duration: 1.5,
          ease: 'easeInOut'
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="absolute top-1/2 left-0 h-px bg-gradient-to-r from-electric via-neon to-cyan -translate-y-1/2 hidden md:block shadow-[0_0_10px_rgba(59,130,246,0.5)]" data-id="element-330"></motion.div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6 relative z-10" data-id="element-331">
            {steps.map((step, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: idx * 0.2
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="flex flex-col items-center text-center md:items-start md:text-left" data-id="element-332">
                <div className="w-12 h-12 rounded-full bg-background border border-white/20 flex items-center justify-center text-white font-bold mb-6 relative shadow-[0_0_15px_rgba(0,0,0,0.5)]" data-id="element-333">
                  {step.num}
                </div>
                <h3 className="text-xl font-semibold text-white mb-2" data-id="element-334">
                  {step.title}
                </h3>
                <p className="text-neutral-400 text-sm" data-id="element-335">{step.desc}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}